module.exports = __webpack_public_path__ + "static/media/noah.89fe225a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/noah.png
// module id = 194
// module chunks = 0